/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

module.exports = function(data) {
  return $.soap({
    body: {
      SubmitExamMTReviewBillingTask: {
        $xmlns: 'http://dobs.pa.gov/nd/task/bpm/1.0',
        TaskID: data.taskId,
        ExamID: data.examId,
        PaymentAmount: data.totalPaymentDue,
        RefundAmountOverride: data.refundAmountOverride,
        IsCloseWoutBilling: data.isCloseWoutBilling,
        PaymentSchedule: (function() {
          var payments = _.map(data.paymentSchedule, function(payment) {
            return {
              Description: payment.description,
              Amount: payment.amount,
              DueDate: payment.dueDate.format('YYYY-MM-DD')
            };
          });
          if (payments) {
            return {
              Payment: payments
            };
          }
        })()
      }
    }
  });
};
